import { render } from "./v-deleteFaq.vue?vue&type=template&id=78df8b46"
import script from "./v-deleteFaq.vue?vue&type=script&lang=js"
export * from "./v-deleteFaq.vue?vue&type=script&lang=js"

import "./v-deleteFaq.vue?vue&type=style&index=0&id=78df8b46&lang=css"
script.render = render

export default script